import React from 'react';
import Card from '../common/Card';
import SafeIcon from '../../common/SafeIcon';
import { motion } from 'framer-motion';

const ZonesView = ({ zones }) => {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="space-y-6">
      <div className="flex justify-between items-end mb-6">
        <div>
          <h2 className="text-2xl font-bold text-white tracking-tight">Facility Map</h2>
          <p className="text-gray-400 mt-1">Real-time zone capacity and environmental monitoring.</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
        {zones.map((zone, idx) => {
          let statusColor = 'text-sp-lime';
          let bgGlow = 'hover:shadow-neon';
          let barColor = 'bg-sp-lime';
          
          if (zone.capacity > 85) {
            statusColor = 'text-orange-400';
            bgGlow = 'hover:shadow-[0_0_15px_rgba(251,146,60,0.3)]';
            barColor = 'bg-orange-400';
          }
          if (zone.capacity > 95) {
            statusColor = 'text-sp-alert';
            bgGlow = 'hover:shadow-neon-alert';
            barColor = 'bg-sp-alert animate-pulse';
          }

          return (
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: idx * 0.05 }}
              key={zone.id}
            >
              <Card className={`h-full border-t-4 transition-all duration-300 ${bgGlow}`} style={{ borderTopColor: barColor }}>
                <div className="flex justify-between items-start mb-4">
                  <div>
                    <div className="text-2xl font-mono font-bold text-white">{zone.id}</div>
                    <div className="text-xs text-gray-500 uppercase tracking-wider">{zone.name}</div>
                  </div>
                  <div className={`p-2 rounded bg-sp-gray-800 ${statusColor}`}>
                    <SafeIcon name="MapPin" />
                  </div>
                </div>

                <div className="space-y-4 mt-auto pt-4">
                  <div>
                    <div className="flex justify-between text-xs font-mono mb-1">
                      <span className="text-gray-400">CAPACITY</span>
                      <span className={statusColor}>{zone.capacity}%</span>
                    </div>
                    <div className="w-full bg-sp-black h-2 rounded-full overflow-hidden">
                      <div className={`h-full ${barColor}`} style={{ width: `${zone.capacity}%` }}></div>
                    </div>
                  </div>

                  <div className="flex justify-between items-center p-2 bg-sp-gray-800/50 rounded border border-sp-gray-800">
                    <div className="flex items-center gap-2">
                       <SafeIcon name="Thermometer" className="text-gray-500 text-sm" />
                       <span className="text-xs text-gray-300 font-mono">TEMP</span>
                    </div>
                    <span className="text-sm font-mono text-white">{zone.temp}</span>
                  </div>
                </div>
              </Card>
            </motion.div>
          );
        })}
      </div>
    </motion.div>
  );
};

export default ZonesView;